import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth.store'
import { ROUTES } from '../routes'

/**
 * Protège les routes qui nécessitent une authentification.
 * - Attend la fin de l'hydratation du store avant de décider
 * - Redirige vers /login si non authentifié
 * - Conserve la page demandée dans le state pour rediriger après login
 */
export function AuthGuard({ children }: { children?: React.ReactNode }) {
  const { isAuthenticated, isLoading, _hasHydrated } = useAuthStore()
  const location = useLocation()

  // ← Attendre que le store soit hydraté depuis localStorage
  // Évite la boucle login ↔ dashboard au démarrage
  if (isLoading || !_hasHydrated) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100vh', background: 'var(--surface-2)',
      }}>
        <div style={{
          width: 36, height: 36, borderRadius: '50%',
          border: '3px solid var(--bd)', borderTopColor: 'var(--brand-orange)',
          animation: 'spin .7s linear infinite',
        }}/>
        <style>{`@keyframes spin { to { transform: rotate(360deg) } }`}</style>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />
  }

  return children ? <>{children}</> : <Outlet />
}
